import { indexBy, prop } from 'ramda';

import { createReducer } from 'utils/ReduxUtils';

import {
  FETCH_APPOINTMENT_TASKS_EVENTS_SUCCESS,
  FETCH_APPOINTMENT_TASKS_EVENTS_FAILURE,
  FETCH_APPOINTMENT_TASKS_EVENTS_REQUEST,
} from '../../../actionTypes';

const initialState = {};

const fetchAppointmentTasksEventsRequestReducer = state => ({
  ...state,
  isLoading: true,
  error: null,
});

const fetchAppointmentTasksEventsFailureReducer = (state, error) => ({
  ...state,
  isLoading: false,
  error,
});

const fetchAppointmentTasksEventsSuccessReducer = (state, { payload, meta }) => {
  const { id } = meta;
  return {
    ...state,
    isLoading: false,
    [id]: {
      ids: indexBy(prop('id'))(payload.content ?? []),
      links: indexBy(prop('rel'))(payload.links),
      page: payload.page,
    },
  };
};

export default createReducer(initialState, {
  [FETCH_APPOINTMENT_TASKS_EVENTS_REQUEST]: fetchAppointmentTasksEventsRequestReducer,
  [FETCH_APPOINTMENT_TASKS_EVENTS_FAILURE]: fetchAppointmentTasksEventsFailureReducer,
  [FETCH_APPOINTMENT_TASKS_EVENTS_SUCCESS]: fetchAppointmentTasksEventsSuccessReducer,
});
